import type { CSSProperties } from 'react';
import type { Tag, TagRef } from '../lib/api';

// One colour per technology domain, used for chips everywhere so a tag looks the same on every page.
const DOMAIN_COLOR: Record<string, string> = {
  microelectronics: '#f5b301',
  autonomy: '#38bdf8',
  'industrial-base': '#fb923c',
  cyber: '#a78bfa',
  biotech: '#34d399',
  'missile-defense': '#fb7185',
  space: '#60a5fa',
};
export const tagColor = (domain: string | undefined): string => DOMAIN_COLOR[domain ?? ''] ?? '#9aa6bd';

export function TagChips({ tags, all, max = 4, showConfidence = false }: { tags: TagRef[] | string[]; all: Tag[]; max?: number; showConfidence?: boolean }) {
  const refs: TagRef[] = tags.map((t) => (typeof t === 'string' ? { tag_id: t, confidence: 1 } : t));
  const shown = refs.slice(0, max);
  return (
    <span className="tag-chips">
      {shown.map((t) => {
        const meta = all.find((x) => x.id === t.tag_id);
        const style = { '--c': tagColor(meta?.domain) } as CSSProperties;
        return (
          <span key={t.tag_id} className="chip" style={style} title={meta ? `${meta.label} (${meta.domain})` : t.tag_id}>
            {meta?.label ?? t.tag_id}{showConfidence && t.confidence < 1 ? <span className="chip-conf">{Math.round(t.confidence * 100)}</span> : null}
          </span>
        );
      })}
      {refs.length > max && <span className="muted sm">+{refs.length - max}</span>}
    </span>
  );
}
